@if (table.ready$ | async) {
  <table mat-table [dataSource]="table.items$" [trackBy]="tableService.trackEntity" matSort (matSortChange)="tableService.handleMatSortChange(table, $event)">
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef><tp-table-selection-header-cell [table]="table"/></th>
      <td mat-cell *matCellDef="let space"><tp-table-selection-cell [table]="table" [row]="space"/></td>
    </ng-container>
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ table.columns.id.name }}</th>
      <td mat-cell *matCellDef="let space">{{ space.id }}</td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ table.columns.name.name }}</th>
      <td mat-cell *matCellDef="let space">{{ space.name }}</td>
    </ng-container>
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ table.columns.createdAt.name }}</th>
      <td mat-cell *matCellDef="let space">{{ space.createdAt | datetime }}</td>
    </ng-container>
    <ng-container matColumnDef="accessLevel">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ table.columns.accessLevel.name }}</th>
      <td mat-cell *matCellDef="let space">{{ space.accessLevel | accessLevel }}</td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let space">
        <button
          mat-fab aria-label="more" [disabled]="!rowPopupMenuItems!(space, (table.accessLevelByUuid$(space.uuid) | async)!).length"
          [matMenuTriggerFor]="rowPopupMenu" [matMenuTriggerData]="{ items: rowPopupMenuItems!(space, (table.accessLevelByUuid$(space.uuid) | async)!) }"
          (click)="$event.stopPropagation()"
        >
          <i class="fa-light fa-ellipsis"></i>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="table.displayedColumns"></tr>
    <tr
      mat-row *matRowDef="let space; columns: table.displayedColumns"
      [class]="tableService.rowClass$(table, space) | async"
      (click)="tableService.handleRowClick(table, space)"
    ></tr>
  </table>
} @else {
  <tp-spinner/>
}

<mat-menu #rowPopupMenu="matMenu">
  <ng-template matMenuContent let-items="items">
    @for (item of items; track item) {
      <button mat-menu-item [matTooltip]="item.disabledReason" [disabled]="item.disabled" (click)="item.action()" [class]="item.dangerous ? 'dangerous' : ''">{{ item.label }}</button>
    }
  </ng-template>
</mat-menu>
